import { render } from "./FirstAndLastName.vue?vue&type=template&id=9858c878&scoped=true"
import script from "./FirstAndLastName.vue?vue&type=script&lang=js"
export * from "./FirstAndLastName.vue?vue&type=script&lang=js"

import "./FirstAndLastName.vue?vue&type=style&index=0&id=9858c878&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9858c878"]])

export default __exports__